<template>
	<div class="page-container">
		<!-- 搜索区域 -->
		<el-card class="search-card" shadow="hover">
			<!-- 修复：移除 .native 修饰符，Vue 3 中直接写 @submit.prevent 即可 -->
			<el-form :model="form" inline @submit.prevent="handleQuery">
				<el-form-item label="物品名称">
					<el-input 
						v-model="form.goodsName" 
						placeholder="请输入物品名称或品牌（如：锂电池、香水）" 
						maxlength="20" 
						clearable 
						style="width: 300px;"
						@keyup.enter="handleQuery"
					>
						<template #prefix>
							<el-icon><Search /></el-icon>
						</template>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleQuery" :loading="loading">
						<el-icon style="margin-right: 5px;"><Search /></el-icon>
						查询限制
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!-- 结果区域 -->
		<el-card class="result-card" shadow="never" v-loading="loading">
			<div v-if="showData && restrictionsList.length > 0">
				<el-table 
					:data="restrictionsList" 
					border 
					stripe 
					style="width: 100%"
					:header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
				>
					<el-table-column prop="goodsName" label="物品名称" width="150" show-overflow-tooltip>
						<template #default="scope">
							<span class="goods-name">{{ scope.row.goodsName }}</span>
						</template>
					</el-table-column>
					
					<el-table-column prop="goodsType" label="物品类型" width="120" show-overflow-tooltip />
					
					<el-table-column prop="restrictionsType" label="寄递限制" width="120" align="center">
						<template #default="scope">
							<el-tag 
								:type="getTagType(scope.row.restrictionsType)" 
								effect="light"
								round
							>
								{{ scope.row.restrictionsType }}
							</el-tag>
						</template>
					</el-table-column>
					
					<el-table-column prop="restrictionsExplanation" label="限制说明" min-width="300">
						<template #default="scope">
							<span 
								class="explanation-text" 
								:class="{ 'forbidden': isForbidden(scope.row) }"
							>
								{{ scope.row.restrictionsExplanation || '-' }}
							</span>
						</template>
					</el-table-column>
					
					<el-table-column prop="suggestInsurance" label="建议保价" width="120" align="center">
						<template #default="scope">
							{{ scope.row.suggestInsurance || '-' }}
						</template>
					</el-table-column>
				</el-table>
			</div>
			
			<!-- 空状态 -->
			<el-empty 
				v-if="!showData || (showData && restrictionsList.length === 0)" 
				:description="emptyText" 
				image-size="100"
			/>
		</el-card>
	</div>
</template>

<script>
	import { Search } from '@element-plus/icons-vue';

	export default {
		components: { Search },
		data() {
			return {
				loading: false,
				form: {
					goodsName: ''
				},
				showData: false,
				restrictionsList: []
			}
		},
		computed: {
			emptyText() {
				if (!this.showData) return '请输入物品名称进行查询';
				return '未找到相关物品的寄递限制信息';
			}
		},
		methods: {
			handleQuery() {
				if (!this.form.goodsName.trim()) {
					this.$message.warning('请输入物品名称');
					return;
				}
				this.query(this.form.goodsName);
			},
			query(goodsName) {
				this.loading = true;
				this.showData = false;
				this.restrictionsList = [];

				this.apiService.post({
						modules: "goodsRestrictions",
						content: {
							goodsName: goodsName
						}
					})
					.then((res) => {
						if (res.status) {
							this.restrictionsList = res.data.restrictionsList || [];
							this.showData = true;
						} else {
							this.$message.error(res.msg || '查询失败');
						}
					})
					.catch(err => {
						console.error(err);
						this.$message.error('网络异常');
					})
					.finally(() => {
						this.loading = false;
					});
			},
			getTagType(type) {
				if (type === '禁止寄递') return 'danger';
				if (type === '限制寄递') return 'warning';
				return 'success';
			},
			isForbidden(row) {
				return row.restrictionsExplanation && row.restrictionsExplanation.includes('禁止寄递');
			}
		}
	}
</script>

<style scoped lang="scss">
	.page-container {
		padding: 20px;
		background-color: #f5f7fa;
		min-height: 100vh;
	}

	.search-card {
		margin-bottom: 20px;
	}

	.result-card {
		min-height: 400px;
	}

	.goods-name {
		font-weight: 500;
		color: #303133;
	}

	.explanation-text {
		color: #606266;
		line-height: 1.5;
		
		&.forbidden {
			color: #f56c6c;
			font-weight: bold;
		}
	}

	:deep(.el-table__body-wrapper)::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}
	:deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb {
		border-radius: 3px;
		background-color: #dcdfe6;
	}
	:deep(.el-table__body-wrapper)::-webkit-scrollbar-track {
		background-color: #f5f7fa;
	}
</style>